import { getLabel, getBucklingPositions } from "../helpers/auxiliary";

import { ng } from "@common/ngds";
import { Lang, ITranslationDatabase } from "../sharedTypes";
import { createDefaultLoadcase, createDefaultLoadcombination } from "../helpers/defaultObject";

export type SymbolName = "R" | "N" | "V1" | "V2" | "T" | "M1" | "M2" | "u" | "v" | "w" | "d" | "wk" | "vp";

export const LOAD_CASE_TYPES_FOR_DROPDOWN_G1 = [
  { name: "type_permanent_load_", id: ng.loadcase.Type.TYPE_PERMANENT_LOAD },
  { name: "type_imposed_load_", id: ng.loadcase.Type.TYPE_IMPOSED_LOAD },
  { name: "type_wind_load_", id: ng.loadcase.Type.TYPE_WIND_LOAD },
  { name: "type_snow_load_", id: ng.loadcase.Type.TYPE_SNOW_LOAD },
  { name: "type_ice_load_", id: ng.loadcase.Type.TYPE_ICE_LOAD },
  { name: "type_soil_load_", id: ng.loadcase.Type.TYPE_SOIL_LOAD },
  { name: "type_accident_load_", id: ng.loadcase.Type.TYPE_ACCIDENT_LOAD },
  { name: "type_seismic_load_", id: ng.loadcase.Type.TYPE_SEISMIC_LOAD },
];

export const LOAD_CASE_TYPES_FOR_DROPDOWN_G2 = [
  { name: "type_permanent_load_", id: ng.loadcase.Type.TYPE_PERMANENT_LOAD },
  { name: "type_imposed_load_", id: ng.loadcase.Type.TYPE_IMPOSED_LOAD },
  { name: "type_wind_load_", id: ng.loadcase.Type.TYPE_WIND_LOAD },
  { name: "type_snow_load_", id: ng.loadcase.Type.TYPE_SNOW_LOAD },
  { name: "type_ice_load_", id: ng.loadcase.Type.TYPE_ICE_LOAD },
  { name: "type_temperature_load_", id: ng.loadcase.Type.TYPE_TEMPERATURE_LOAD },
  { name: "type_soil_load_", id: ng.loadcase.Type.TYPE_SOIL_LOAD },
  { name: "type_accident_load_", id: ng.loadcase.Type.TYPE_ACCIDENT_LOAD },
  { name: "type_seismic_load_", id: ng.loadcase.Type.TYPE_SEISMIC_LOAD },
  { name: "type_construction_load_", id: ng.loadcase.Type.TYPE_CONSTRUCTION_LOAD },
];

export const LOAD_COMBINATION_TYPES_FOR_DROPDOWN = [
  { name: "type_characteristic_", id: ng.loadcombination.Type.TYPE_CHARACTERISTIC },
  { name: "type_frequent_", id: ng.loadcombination.Type.TYPE_FREQUENT },
  { name: "type_quasi_perm_", id: ng.loadcombination.Type.TYPE_QUASI_PERMANENT },
  { name: "type_ultimate_", id: ng.loadcombination.Type.TYPE_ULTIMATE },
  { name: "type_accidental_", id: ng.loadcombination.Type.TYPE_ACCIDENTAL },
  { name: "type_fire_", id: ng.loadcombination.Type.TYPE_FIRE },
  { name: "type_seismic_", id: ng.loadcombination.Type.TYPE_SEISMIC },
];

export const LOADCASE_CATEGORIES_FOR_DROPDOWN_G1 = [
  { name: "loadcase_category_A_", id: ng.loadcase.Category.CATEGORY_A },
  { name: "loadcase_category_B_", id: ng.loadcase.Category.CATEGORY_B },
  { name: "loadcase_category_C_", id: ng.loadcase.Category.CATEGORY_C },
  { name: "loadcase_category_D_", id: ng.loadcase.Category.CATEGORY_D },
  { name: "loadcase_category_E_", id: ng.loadcase.Category.CATEGORY_E },
  { name: "loadcase_category_F_", id: ng.loadcase.Category.CATEGORY_F },
  { name: "loadcase_category_G_", id: ng.loadcase.Category.CATEGORY_G },
  { name: "loadcase_category_H_", id: ng.loadcase.Category.CATEGORY_H },
];

export const LOADCASE_CATEGORIES_FOR_DROPDOWN_G2 = [
  { name: "loadcase_category_A_", id: ng.loadcase.Category.CATEGORY_A },
  { name: "loadcase_category_B_", id: ng.loadcase.Category.CATEGORY_B },
  { name: "loadcase_category_C_", id: ng.loadcase.Category.CATEGORY_C },
  { name: "loadcase_category_D_", id: ng.loadcase.Category.CATEGORY_D },
  { name: "loadcase_category_E_", id: ng.loadcase.Category.CATEGORY_E },
  { name: "loadcase_category_F_", id: ng.loadcase.Category.CATEGORY_F },
  { name: "loadcase_category_G_", id: ng.loadcase.Category.CATEGORY_G },
  { name: "loadcase_category_H_forG2_", id: ng.loadcase.Category.CATEGORY_H },
  { name: "loadcase_category_G2_", id: ng.loadcase.Category.CATEGORY_G2 },
  { name: "loadcase_category_I1_", id: ng.loadcase.Category.CATEGORY_I1 },
  { name: "loadcase_category_I2_", id: ng.loadcase.Category.CATEGORY_I2 },
  { name: "loadcase_category_I3_", id: ng.loadcase.Category.CATEGORY_I3 },
  { name: "loadcase_category_K_", id: ng.loadcase.Category.CATEGORY_K },
  { name: "loadcase_category_S1_", id: ng.loadcase.Category.CATEGORY_S1 },
  { name: "loadcase_category_S2_", id: ng.loadcase.Category.CATEGORY_S2 },
  { name: "loadcase_category_S3_C_G_", id: ng.loadcase.Category.CATEGORY_S3_C_G },
  { name: "loadcase_category_S3_H_K_", id: ng.loadcase.Category.CATEGORY_S3_H_K },
  { name: "loadcase_category_T_", id: ng.loadcase.Category.CATEGORY_T },
];

export const DURATION_CLASSES_FOR_DROPDOWN = [
  { name: "duration_class_permanent_", id: ng.loadcase.DurationClass.DURATION_CLASS_PERMANENT },
  { name: "duration_class_long_", id: ng.loadcase.DurationClass.DURATION_CLASS_LONG },
  { name: "duration_class_medium_", id: ng.loadcase.DurationClass.DURATION_CLASS_MEDIUM },
  { name: "duration_class_short_", id: ng.loadcase.DurationClass.DURATION_CLASS_SHORT },
  { name: "duration_class_instantaneous_", id: ng.loadcase.DurationClass.DURATION_CLASS_INSTANTANEOUS },
];

export const COA_TYPE_G1 = [
  { name: "uls_type_610_", id: ng.loadcombination.CoaType.COA_TYPE_610 },
  { name: "uls_type_610a_", id: ng.loadcombination.CoaType.COA_TYPE_610A },
  { name: "uls_type_610b_", id: ng.loadcombination.CoaType.COA_TYPE_610B },
  { name: "uls_type_611ab_", id: ng.loadcombination.CoaType.COA_TYPE_611AB },
  { name: "sls_type_614b_", id: ng.loadcombination.CoaType.COA_TYPE_614B },
  { name: "sls_type_615b_", id: ng.loadcombination.CoaType.COA_TYPE_615B },
  { name: "sls_type_616b_", id: ng.loadcombination.CoaType.COA_TYPE_616B },
];

export const COA_TYPE_G2 = [
  { name: "uls_type_812_", id: ng.loadcombination.CoaType.COA_TYPE_812 },
  { name: "uls_type_813a_", id: ng.loadcombination.CoaType.COA_TYPE_813A },
  { name: "uls_type_813b_", id: ng.loadcombination.CoaType.COA_TYPE_813B },
  { name: "uls_type_814a_", id: ng.loadcombination.CoaType.COA_TYPE_814A },
  { name: "uls_type_814b_", id: ng.loadcombination.CoaType.COA_TYPE_814B },
  { name: "uls_type_815_", id: ng.loadcombination.CoaType.COA_TYPE_815 },
  { name: "uls_type_816_", id: ng.loadcombination.CoaType.COA_TYPE_816 },
  { name: "sls_type_829_", id: ng.loadcombination.CoaType.COA_TYPE_829 },
  { name: "sls_type_830_", id: ng.loadcombination.CoaType.COA_TYPE_830 },
  { name: "sls_type_831_", id: ng.loadcombination.CoaType.COA_TYPE_831 },
];

export class Vector {
  data: ng.geometry.Vector3D;
  constructor(x: number, y: number, z: number) {
    this.data = ng.geometry.Vector3D.create({ x: x, y: y, z: z });
  }

  length() {
    return Math.hypot(this.data.x, this.data.y, this.data.z);
  }

  dotProduct(v: Vector) {
    return this.data.x * v.data.x + this.data.y * v.data.y + this.data.z * v.data.z;
  }

  crossProduct(v: Vector) {
    return new Vector(
      this.data.y * v.data.z - this.data.z * v.data.y,
      this.data.z * v.data.x - this.data.x * v.data.z,
      this.data.x * v.data.y - this.data.y * v.data.x,
    );
  }

  angleBetween(vx: Vector) {
    let angle = Math.acos(this.dotProduct(vx) / (this.length() * vx.length()));
    let cross = this.crossProduct(vx);
    let n = cross.data.y;
    if (n < 0) {
      angle *= -1;
    }
    return angle;
  }
}

interface VectorLike {
  x: number;
  y: number;
  z: number;
}

export function DeriveRot(v: VectorLike) {
  if (v.x === null || v.y === null || v.z === null) return Math.PI;

  const vx = new Vector(1.0, 0.0, 0.0);
  const vi = new Vector(v.x, v.y, v.z);

  let rot = vi.angleBetween(vx);

  return rot;
}

export function DeriveDir(angle: number) {
  let x = Math.cos(angle);
  let y = 0;
  let z = Math.sin(angle);

  return ng.geometry.Vector3D.create({ x: x, y: y, z: z });
}

export function CreateGUID() {
  return crypto.randomUUID();
}

export function createID(name: string) {
  const newID = ng.utils.ID.create({
    guid: CreateGUID(),
    name: name,
    eTag: "",
  });

  return newID;
}


export type ErrorType = "error_" | "warning_" | "warning_unstable" | "information_";

export const AddToastWarning = (localisation: ITranslationDatabase, lang: Lang, textLabel: string) => {
  let context = "";
  let text = getLabel(localisation, lang, textLabel);
  const status = getLabel(localisation, lang, "warning_");
};

// NOTE: gamma value auto-updates (kdef/kcr + partial factors) are handled by the
// `updateGammaApi` redux thunk in features/projects/projectSlice.ts, which posts the project
// to /api/code/updateGamma and replaces the project on success.

// Sends the entire project to the server for updating the load combination factors
export const updateLoadCombFactors = (
  project: ng.project.Data,
  localisation: ITranslationDatabase,
  lang: Lang,
  fPushChg: () => void,
) => {
  let input = ng.endpoint_args.eurocode.UpdateFactorsArgsIn.create({ input: project.input });
  /*
  // Call the code service to update the load combination factors
fetch('/code/updateLoadCombFactors', {
    method: 'POST',
    headers: {  'Content-Type': 'application/json' })

  http.post('/code/updateLoadCombFactors',
    ng.endpoint_args.eurocode.UpdateFactorsArgsIn.toObject(input),
    async (output) => {

      // Parse the updated project and update the context
      let argsOut = ng.endpoint_args.eurocode.UpdateFactorsArgsOut.fromObject(output);
      if (context.proj?.data) {
        context.proj.data.input = argsOut.updatedInput;
        fPushChg();
      }

    },
    async (error) => {
      let msg = getLabel(localisation, lang, "MSG_update_factors_failed_", true);
      AlertMessage("error_", getLabel(localisation, lang, "error_"), "", msg);
    });
    */
};

// Returns the material type associated with the current beam
export const getCurrentMaterialType = (project: ng.project.Data) => {
  if (project && project.input) {
    let input = project.input;

    if (input.structures && input.structures[0] && input.structures[0].elements && input.structures[0].elements[0]) {
      let element = input.structures[0].elements[0];

      if (element.element?.type === "beam") {
        let mat = input.mtrlDb.find(
          (mtrl) => mtrl.id?.guid && element?.getBeam()?.mtrlGuid && mtrl.id?.guid === element?.getBeam()?.mtrlGuid,
        );
        if (mat) {
          return mat.type;
        }
      }
    }
  }

  return ng.material.Mtrl.MTRL_UNSPECIFIED;
};

// Returns the material associated with the current beam
export const getCurrentMaterial = (project: ng.project.Data) => {
  if (project && project.input) {
    let input = project.input;

    if (input.structures && input.structures[0] && input.structures[0].elements && input.structures[0].elements[0]) {
      let element = input.structures[0].elements[0];

      if (element.element?.type === "beam") {
        let mat = input.mtrlDb.find(
          (mtrl) => mtrl.id?.guid && element?.getBeam()?.mtrlGuid && mtrl.id?.guid === element?.getBeam()?.mtrlGuid,
        );
        if (mat) {
          return mat;
        }
      }
    }
  }

  return null;
};

const indexOf = <T,>(arr: T[] | undefined, index: number): T | undefined => {
  if (arr === undefined) return undefined;
  if (arr.length <= index) return undefined;
  return arr[index];
};

// Returns the section associated with the current beam
export const getCurrentSection = (project: ng.project.Data) => {
  if (project && project.input) {
    let input = project.input;

    if (input.structures && input.structures[0] && input.structures[0].elements && input.structures[0].elements[0]) {
      let element = input.structures[0].elements[0];

      const start = indexOf(element?.getBeam()?.segments, 0)?.layer?.start;
      if (start) {
        let secGuid = start.secGuid;
        let sec = input.secDb.find((sec) => sec.id?.guid && sec.id?.guid === secGuid);
        if (sec) {
          return sec;
        }
      }
    }
  }

  return null;
};

// Sends the entire project to the server for all load combinations to be regenerated
export const reGenerateLoadCombs = async (
  proj: ng.project.Data,
  settings: any,
  cache: ng.frontend.column.EndPointParamCache | undefined,
  localisation: ITranslationDatabase,
  lang: Lang,
  call: () => void,
) => {
  let project = proj.input;
  let structure = ng.structure.Data.create();
  let loading = ng.loading.Data.create();
  let stage = ng.stage.Data.create();

  if (project && project.structures && project.structures[0]?.loading) {
    structure = project.structures[0];
    if (structure.loading) {
      loading = structure.loading;
    }
    if (structure.stages && structure.stages[0]) {
      stage = structure.stages[0];
    }
  }

  if (!proj) throw new Error("c.proj is undefined");
  settings = settings ?? ng.frontend.column.FrontendData.create();

  // Create a new cache with default values if one does not exist
  let allLoadcases = loading.loadcases.map((lc) => lc.id?.guid).filter((guid) => guid !== undefined) as string[];
  let defaultLCTypes = [ng.loadcombination.Type.TYPE_ULTIMATE];

  if (!cache) {
    cache = ng.frontend.column.EndPointParamCache.create({
      loadCombGenSettings: ng.endpoint_args.eurocode.LoadCombGenSettings.create({
        lcTypes: defaultLCTypes,
        loadcases: allLoadcases,
        simple: ng.endpoint_args.eurocode.Simple.create({
          includePermanentLoadFavorable: false,
        }),
      }),
      autoDesign: null,
    });

    settings.endpointCache = cache;
  }

  if (cache.loadCombGenSettings === undefined) {
    cache.loadCombGenSettings = ng.endpoint_args.eurocode.LoadCombGenSettings.create({
      lcTypes: defaultLCTypes,
      loadcases: allLoadcases,
      simple: ng.endpoint_args.eurocode.Simple.create({
        includePermanentLoadFavorable: false,
      }),
    });
  }

  // Prepare the input for the load combination generator endpoint
  let input = ng.endpoint_args.eurocode.LoadCombGenArgsIn.create({
    projectData: project,
    settings: cache.loadCombGenSettings,
  });

  // Call the load combination generator endpoint
  let resp = await fetch("/code/generateLoadCombs", {
    method: "POST",
    body: JSON.stringify(ng.endpoint_args.eurocode.LoadCombGenArgsIn.toObject(input)),
  });
  let output = await resp.json();
  // Parse the updated project and update the context
  let argsOut = ng.endpoint_args.eurocode.LoadCombGenArgsOut.fromObject(output);
  if (loading && loading.combinations) {
    // Filter out the user defined load combinations
    let userDefined = loading.combinations.filter((lco) => lco.userDefined === true);

    // Filter out the user defined load combinations, and check if any are deactivated (means all are)
    let generated = loading.combinations.filter((lco) => lco.userDefined === false);

    let deactivated = generated.length === 0 ? true : false;
    for (var lc of generated) {
      if (lc.deactive) {
        deactivated = true;
        break;
      }
    }

    // Re-set deactive flag for the new load combinations
    var newLoadcombinations = [...argsOut.loadcombinations];
    for (var newLC of newLoadcombinations) {
      newLC.deactive = deactivated;
    }

    // Let's overwrite the existing load combinations for now
    loading.combinations = newLoadcombinations;

    // Add the user defined load combinations back
    loading.combinations = loading.combinations.concat(userDefined);

    // Update the stage with the new load combinations guids
    stage.lcombGuids = loading.combinations.map((lco) => lco.id?.guid).filter((guid) => guid !== undefined) as string[];
  }
  // trigger provided callback
  return proj;
};

export const createEnvelopes = (lcos: ng.loadcombination.IData[]) => {
  function filterItems(arr: ng.loadcombination.IData[], query: ng.loadcombination.Type) {
    return arr.filter((e) => e.type === query);
  }

  //----------------------------------------------------
  let tmpLCOs = [];

  //remove the lco's that are deactivated
  for (let lco of lcos) {
    if (!lco.deactive) {
      tmpLCOs.push(lco);
    }
  }

  //first set up an array of active type's
  let types = [];
  for (let lco of tmpLCOs) {
    if (types.findIndex((e) => e === lco.type) === -1) {
      types.push(lco.type);
    }
  }

  //then create an array of lco's (=envelope) for each coa
  for (let type of types) {
    if (type) {
      let env = filterItems(tmpLCOs, type);
      if (env.length > 1) {
        let arrLco = [];
        for (let lco of env) {
          let tmpLco = createDefaultLoadcase(); // yes this is a load combination disguised as a load case
          if (tmpLco.id && lco.id) {
            tmpLco.id.guid = lco.id.guid; // we want to collect the guid of each load combination that should be in the envelope
          }
          arrLco.push(tmpLco);
        }

        //The 'envelope' is a "load combination" made up from all load combinations that has the same type
        let envelope = createDefaultLoadcombination(arrLco);

        if (envelope.id) {
          envelope.type = ng.loadcombination.Type.TYPE_UNSPECIFIED;
          envelope.id.guid = "envelope_" + arrLco[0].id?.guid; //CreateGUID();
          envelope.id.name = "ENV: " + LOAD_COMBINATION_TYPES_FOR_DROPDOWN[type - 1].name || "";
        }

        tmpLCOs.unshift(envelope); // put the envelopes at the beginning of the load combinations
      }
    }
  }

  return tmpLCOs;
};

export const updateActiveLcosInContext = (proj: ng.project.Data) => {
  const loadcombinations = proj?.input?.structures[0].loading?.combinations ?? [];

  const activeLCOs = createEnvelopes(loadcombinations);
  // if (context.activeLCOs === undefined || hash(activeLCOs) !== hash(context.activeLCOs)) {
  // only push if we changed the activeLCOs
  // context.activeLCOs = activeLCOs;
  return activeLCOs;
};

export const IsBucklingOK = (
  proj: ng.project.Data,
  localisation: ITranslationDatabase,
  lang: Lang,

  setSupPos?: (pos: number[]) => void,
  setTopSpanPos?: (pos: number[]) => void,
  setBtmSpanPos?: (pos: number[]) => void,
  setStiffSpanPos?: (pos: number[]) => void,
  setWeakSpanPos?: (pos: number[]) => void,
  setTopBetas?: (betas: number[]) => void,
  setBtmBetas?: (betas: number[]) => void,
  setStiffBetas?: (betas: number[]) => void,
  setWeakBetas?: (betas: number[]) => void,
  setEdgeSpanPos?: (pos: number[]) => void,
  setLtsCond?: (cond: ng.beam.SupportCondition[]) => void,
) => {
  let project = proj.input;
  let structure = new ng.structure.Data();
  let element = new ng.element.Data();
  let genBeam = new ng.beam.Data();
  let beam: ng.beam.SteelElement | ng.beam.TimberElement | ng.beam.ConcreteElement | null = null;
  let seg = new ng.beam.Segment();
  let elemL: number = 0;
  let stage = new ng.stage.Data();

  if (project && project.structures && project.structures[0]?.loading) {
    structure = project.structures[0];
    if (structure.stages && structure.stages[0]) {
      stage = structure.stages[0];
    }

    if (structure.elements && structure.elements[0]) {
      element = structure.elements[0];
      if (element.element?.type === "beam") {
        genBeam = element.element.beam;
        if (genBeam.segments) {
          seg = genBeam.segments[0];
          elemL = seg.length || 0;
        }

        //steel
        if (genBeam.element?.type === "steel") {
          beam = genBeam.element.steel;
        }
        //timber
        if (genBeam.element?.type === "timber") {
          beam = genBeam.element.timber;
        }
        //rc
        if (genBeam.element?.type === "concrete") {
          beam = genBeam.element.concrete;
        }
      }
    }
  }

  const weakPos = getBucklingPositions(stage, "weak");

  let topBetas: number[] = [];
  let btmBetas: number[] = [];
  let topPos: number[] = [];
  let btmPos: number[] = [];
  let supCond: ng.beam.SupportCondition[] = [];
  let edgePos: number[] = [];

  if (beam instanceof ng.beam.SteelElement) {
    if (beam.ltbTop) {
      topBetas = beam.ltbTop.betas;
      topPos = getBucklingPositions(stage, "top");
    }
    if (beam.ltbBtm) {
      btmBetas = beam.ltbBtm.betas;
      btmPos = getBucklingPositions(stage, "btm");
    }
  }

  if (beam instanceof ng.beam.TimberElement) {
    if (beam.ltsb) {
      supCond = beam.ltsb.supportConditions;
      edgePos = getBucklingPositions(stage, "top");
    }
  }

  let stiffBetas = beam?.fbStiff?.betas;
  let weakBetas = beam?.fbWeak?.betas;

  let OK = true;

  // supports --------------------------------
  let supPos = [] as number[];
  let tmpPos = [] as number[];

  for (let sup of stage.sups || []) {
    if (!sup.lateral && sup.position?.type === "coord" && sup.position.coord.x != null) {
      tmpPos.push(sup.position.coord.x);
    }
  }
  if (stage.sups) {
    tmpPos.sort(function (a, b) {
      return a - b;
    }); // order
    supPos = structuredClone(tmpPos);
    if (setSupPos) setSupPos(structuredClone(tmpPos));
  }

  // spans ====================================

  // top flange --------------------------------

  if (beam instanceof ng.beam.SteelElement) {
    tmpPos = structuredClone(topPos);
    //add start and end of beam so that beta-curves can be drawn
    tmpPos.unshift(0);
    tmpPos.push(elemL);

    //if normal (not lateral) supports are at this level -> include them as well
    for (let sup of stage.sups || []) {
      if (!sup.lateral && sup.supportLevel === ng.stage.SupportLevel.SUPPORT_LEVEL_TOP) {
        const xCoord = sup.getCoord()?.x;
        if (xCoord) {
          tmpPos.push(xCoord);
        }
      }
    }

    tmpPos = [...new Set(tmpPos)]; //remove duplicates
    tmpPos.sort(function (a, b) {
      return a - b;
    }); // order

    if (tmpPos.length - 1 !== topBetas?.length) {
      //AlertMessage("warning_", getLabel(localisation, lang, "warning_"), "", getLabel(localisation, lang, "MSG_buckling_spans_and_betas_mismatch_"));
      console.log("error in buckling spans/betas");
      OK = false;

      //always let the positions rule over betas i.e. adjust the betas
      if (beam.ltbTop) {
        let ltb = beam.ltbTop.deepClone();

        let betas: number[] = [];
        let data: ng.beam.BucklingData[] = [];

        for (let i = 0; i < tmpPos.length - 1; i++) {
          betas.push(1.0);
          let pos = ng.beam.BucklingSpan.create({ start: tmpPos[i], end: tmpPos[i + 1] });
          let tmp = ng.beam.BucklingData.create({ position: pos, beta: 1.0 });
          data.push(tmp);
        }

        ltb.betas = structuredClone(betas);
        ltb.data = data.map((x) => x.deepClone());

        beam.ltbTop = ltb;

        if (setTopBetas) setTopBetas(structuredClone(betas));
      }
    }

    // secure that the beta values are the same in both betas and in data
    if (beam.ltbTop) {
      for (let i = 0; i < beam.ltbTop?.betas.length; i++) {
        if (beam.ltbTop?.data[i].getBeta() !== beam.ltbTop?.betas[i]) {
          beam.ltbTop.data[i].setBeta(beam.ltbTop.betas[i]);
        }
      }
    }

    if (setTopSpanPos) setTopSpanPos(tmpPos);

    // bottom flange --------------------------------

    tmpPos = structuredClone(btmPos);
    //add start and end of beam so that beta-curves can be drawn
    tmpPos.unshift(0);
    tmpPos.push(elemL);

    //if normal (not lateral) supports are at this level -> include them as well
    for (let sup of stage.sups || []) {
      if (!sup.lateral && sup.supportLevel === ng.stage.SupportLevel.SUPPORT_LEVEL_BOTTOM) {
        const xCoord = sup.getCoord()?.x;
        if (xCoord) {
          tmpPos.push(xCoord);
        }
      }
    }

    tmpPos = [...new Set(tmpPos)]; //remove duplicates
    tmpPos.sort(function (a, b) {
      return a - b;
    }); // order

    if (tmpPos.length - 1 !== btmBetas?.length) {
      //AlertMessage("warning_", getLabel(localisation, lang, "warning_"), "", getLabel(localisation, lang, "MSG_buckling_spans_and_betas_mismatch_"));
      console.log("error in buckling spans/betas");
      OK = false;

      //always let the positions rule over betas i.e. adjust the betas
      if (beam.ltbBtm) {
        let ltb = beam.ltbBtm.deepClone();

        let betas: number[] = [];
        let data: ng.beam.BucklingData[] = [];

        for (let i = 0; i < tmpPos.length - 1; i++) {
          betas.push(1.0);
          let pos = ng.beam.BucklingSpan.create({ start: tmpPos[i], end: tmpPos[i + 1] });
          let tmp = ng.beam.BucklingData.create({ position: pos, beta: 1.0 });
          data.push(tmp);
        }

        ltb.betas = structuredClone(betas);
        ltb.data = data.map((x) => x.deepClone());

        beam.ltbBtm = ltb;

        if (setBtmBetas) setBtmBetas(structuredClone(betas));
      }
    }

    // secure that the beta values are the same in both betas and in data
    if (beam.ltbBtm) {
      for (let i = 0; i < beam.ltbBtm?.betas.length; i++) {
        if (beam.ltbBtm?.data[i].getBeta() !== beam.ltbBtm?.betas[i]) {
          beam.ltbBtm.data[i].setBeta(beam.ltbBtm.betas[i]);
        }
      }
    }

    if (setBtmSpanPos) setBtmSpanPos(tmpPos);
  }

  //stiff --------------------------------

  tmpPos = structuredClone(supPos);
  //add start and end of beam so that beta-curves can be drawn
  tmpPos.unshift(0);
  tmpPos.push(elemL);

  //if normal (not lateral) supports are at this level -> include them as well
  for (let sup of stage.sups || []) {
    if (!sup.lateral) {
      const xCoord = sup.getCoord()?.x;
      if (xCoord) {
        tmpPos.push(xCoord);
      }
    }
  }

  tmpPos = [...new Set(tmpPos)]; //remove duplicates
  tmpPos.sort(function (a, b) {
    return a - b;
  }); // order

  if (tmpPos.length - 1 !== stiffBetas?.length) {
    // AlertMessage("warning_", getLabel(localisation, lang, "warning_"), "", getLabel(localisation, lang, "MSG_buckling_spans_and_betas_mismatch_"));
    console.log("error in buckling spans/betas");
    OK = false;

    //always let the positions rule over betas i.e. adjust the betas
    if (beam && beam.fbStiff) {
      let fb = beam.fbStiff.deepClone();

      let betas: number[] = [];
      let data: ng.beam.BucklingData[] = [];

      for (let i = 0; i < tmpPos.length - 1; i++) {
        betas.push(1.0);
        let pos = ng.beam.BucklingSpan.create({ start: tmpPos[i], end: tmpPos[i + 1] });
        let tmp = ng.beam.BucklingData.create({ position: pos, beta: 1.0 });
        data.push(tmp);
      }

      fb.betas = structuredClone(betas);
      fb.data = data.map((x) => x.deepClone());

      beam.fbStiff = fb;

      if (setStiffBetas) setStiffBetas(structuredClone(betas));
    }
  }

  // secure that the beta values are the same in both betas and in data
  if (beam && beam.fbStiff) {
    for (let i = 0; i < beam.fbStiff?.betas.length; i++) {
      if (beam.fbStiff?.data[i].getBeta() !== beam.fbStiff?.betas[i]) {
        beam.fbStiff.data[i].setBeta(beam.fbStiff.betas[i]);
      }
    }
  }

  if (setStiffSpanPos) setStiffSpanPos(tmpPos);

  // weak --------------------------------

  tmpPos = structuredClone(weakPos);
  //add start and end of beam so that beta-curves can be drawn
  tmpPos.unshift(0);
  tmpPos.push(elemL);

  //if normal (not lateral) supports are at this level -> include them as well
  for (let sup of stage.sups || []) {
    if (!sup.lateral && sup.supportLevel === ng.stage.SupportLevel.SUPPORT_LEVEL_CENTER) {
      const xCoord = sup.getCoord()?.x;
      if (xCoord) {
        tmpPos.push(xCoord);
      }
    }
  }

  tmpPos = [...new Set(tmpPos)]; //remove duplicates
  tmpPos.sort(function (a, b) {
    return a - b;
  }); // order

  if (tmpPos.length - 1 !== weakBetas?.length) {
    //AlertMessage("warning_", getLabel(localisation, lang, "warning_"), "", getLabel(localisation, lang, "MSG_buckling_spans_and_betas_mismatch_"));

    console.log("error in buckling spans/betas");
    OK = false;

    //always let the positions rule over betas i.e. adjust the betas
    if (beam && beam.fbWeak) {
      let fb = beam.fbWeak.deepClone();

      let betas: number[] = [];
      let data: ng.beam.BucklingData[] = [];

      for (let i = 0; i < tmpPos.length - 1; i++) {
        betas.push(1.0);
        let pos = ng.beam.BucklingSpan.create({ start: tmpPos[i], end: tmpPos[i + 1] });
        let tmp = ng.beam.BucklingData.create({ position: pos, beta: 1.0 });
        data.push(tmp);
      }

      fb.betas = structuredClone(betas);
      fb.data = data.map((x) => x.deepClone());

      beam.fbWeak = fb;

      if (setWeakBetas) setWeakBetas(structuredClone(betas));
    }
  }

  // secure that the beta values are the same in both betas and in data
  if (beam && beam.fbWeak) {
    for (let i = 0; i < beam.fbWeak?.betas.length; i++) {
      if (beam.fbWeak?.data[i].getBeta() !== beam.fbWeak?.betas[i]) {
        beam.fbWeak.data[i].setBeta(beam.fbWeak.betas[i]);
      }
    }
  }

  if (setWeakSpanPos) setWeakSpanPos(tmpPos);

  if (beam instanceof ng.beam.TimberElement) {
    // edge --------------------------------

    tmpPos = [...edgePos];
    //add start and end of beam so that beta-curves can be drawn
    tmpPos.unshift(0);
    tmpPos.push(elemL);

    //if normal (not lateral) supports are at this level -> include them as well
    for (let sup of stage.sups || []) {
      if (!sup.lateral && sup.supportLevel === ng.stage.SupportLevel.SUPPORT_LEVEL_TOP) {
        const xCoord = sup.getCoord()?.x;
        if (xCoord) {
          tmpPos.push(xCoord);
        }
      }
    }

    tmpPos = [...new Set(tmpPos)]; //remove duplicates
    tmpPos.sort(function (a, b) {
      return a - b;
    }); // order

    if (tmpPos.length - 1 !== supCond?.length) {
      //AlertMessage("warning_", getLabel(localisation, lang, "warning_"), "", getLabel(localisation, lang, "MSG_buckling_spans_and_betas_mismatch_"));
      console.log("error in buckling spans/betas");
      OK = false;

      //always let the positions rule over betas i.e. adjust the betas
      if (beam.ltsb) {
        let ltsb = beam.ltsb.deepClone();

        let supCond: ng.beam.SupportCondition[] = [];
        let data: ng.beam.BucklingData[] = [];

        for (let i = 0; i < tmpPos.length - 1; i++) {
          supCond.push(ng.beam.SupportCondition.SUPPORT_CONDITION_SIMPLY);
          let pos = ng.beam.BucklingSpan.create({ start: tmpPos[i], end: tmpPos[i + 1] });
          let tmp = ng.beam.BucklingData.create({ position: pos, beta: 1.0 });
          data.push(tmp);
        }

        ltsb.supportConditions = structuredClone(supCond);
        ltsb.data = data.map((x) => x.deepClone());

        beam.ltsb = ltsb;

        if (setLtsCond) setLtsCond(structuredClone(supCond));
      }
    }

    // secure that the support conditions are the same in both supportCondition and in data
    if (beam.ltsb) {
      for (let i = 0; i < beam.ltsb?.supportConditions.length; i++) {
        if (beam.ltsb?.data[i].getSupportCondition() !== beam.ltsb?.supportConditions[i]) {
          beam.ltsb.data[i].setSupportCondition(beam.ltsb.supportConditions[i]);
        }
      }
    }

    if (setEdgeSpanPos) setEdgeSpanPos(tmpPos);
  }

  ///if (!OK && pushChanges) pushChanges(context);

  return OK;
};

export const CheckLoadDir = (proj: ng.project.Data) => {
  let project = proj?.input;
  let loads: ng.load.IData[] = [];

  if (project && project.structures && project.structures[0]?.loading) {
    loads = project.structures[0].loading.loads || [];

    let tmpLoads = loads.map((x) => x.deepClone());

    for (let load of tmpLoads) {
      if (load.direction) {
        let dir = load.direction;

        load.direction.x = Math.abs(dir.x) < 1e-6 ? 0 : dir.x;
        load.direction.y = dir.y;
        load.direction.z = 1 - Math.abs(dir.z) < 1e-6 ? (dir.z > 0 ? 1 : -1) : dir.z;
      }
    }

    project.structures[0].loading.loads = tmpLoads;

    // if (pushChanges) pushChanges(context); need to update sliec
  }

  return true;
};

//================================================================================================

// ======== Section dedicated to handling self-weight =========

export const GetSelfWeightGuid = (lcas: ng.loadcase.IData[]) => {
  let selfWeightGuid = "";
  for (let lca of lcas) {
    if (ng.loadcase.Type_FromObject(lca.type) === ng.loadcase.Type.TYPE_SELF_WEIGHT) {
      selfWeightGuid = lca.id?.guid || "";
      break;
    }
  }
  return selfWeightGuid;
};

export const interpolate = (
  pos: ng.result.PositionResult,
  prevPos: ng.result.PositionResult,
  endX: number,
  x: number,
  dof: number,
  type: string,
  newPos: ng.result.PositionResult,
) => {
  const x1 = prevPos.getDistance() ?? 0;
  const x2 = endX;
  let y1 = 0;
  let y2 = 0;

  if (type === "force") {
    y1 = prevPos.results?.force?.value[dof] ?? 0;
    y2 = pos.results?.force?.value[dof] ?? 0;
  }

  if (type === "disp") {
    y1 = prevPos.results?.displacement?.value[dof] ?? 0;
    y2 = pos.results?.displacement?.value[dof] ?? 0;
  }

  let val = y1;
  if (Math.abs(x1 - x2) > 2.1e-3) {
    // the distance between two "double"-points is 2 mm so 2.1 assures that we find these
    val = y1 + (y2 - y1) * ((x - x1) / (x2 - x1));
  }

  if (newPos.results) {
    if (type === "force") {
      if (newPos.results.force) {
        newPos.results.force.value[dof] = val;
      }
    }
    if (type === "disp") {
      if (newPos.results.displacement) {
        newPos.results.displacement.value[dof] = val;
      }
    }
  }
};

export const isULS = (lco: ng.loadcombination.Data) => {
  switch (lco.type) {
    case ng.loadcombination.Type.TYPE_ACCIDENTAL:
    case ng.loadcombination.Type.TYPE_FIRE:
    case ng.loadcombination.Type.TYPE_SEISMIC:
    case ng.loadcombination.Type.TYPE_ULTIMATE:
      return true;
    default:
      return false;
  }
};

export const isSLS = (lco: ng.loadcombination.Data) => {
  switch (lco.type) {
    case ng.loadcombination.Type.TYPE_CHARACTERISTIC:
    case ng.loadcombination.Type.TYPE_FREQUENT:
    case ng.loadcombination.Type.TYPE_QUASI_PERMANENT:
      return true;
    default:
      return false;
  }
};

export const migrateGeneration = (
  input: ng.input.Data,
  fromGen: ng.eurocode.Generation,
  toGen: ng.eurocode.Generation,
): ng.input.Data => {
  if (fromGen === toGen) return input;

  if (!input || !input.getEc()) {
    return input;
  }

  if (fromGen === ng.eurocode.Generation.GENERATION_1 && toGen === ng.eurocode.Generation.GENERATION_2) {
    for (let structure of input.structures || []) {
      if (structure.loading) {
        for (let loadcomb of structure.loading.combinations || []) {
          switch (loadcomb.coa) {
            case ng.loadcombination.CoaType.COA_TYPE_610:
            case ng.loadcombination.CoaType.COA_TYPE_610A:
            case ng.loadcombination.CoaType.COA_TYPE_610B:
            case ng.loadcombination.CoaType.COA_TYPE_610A3:
            case ng.loadcombination.CoaType.COA_TYPE_610B4:
            case ng.loadcombination.CoaType.COA_TYPE_6105:
            case ng.loadcombination.CoaType.COA_TYPE_611AB:
            case ng.loadcombination.CoaType.COA_TYPE_614B:
            case ng.loadcombination.CoaType.COA_TYPE_615B:
            case ng.loadcombination.CoaType.COA_TYPE_616B:
            default:
              break; // do nothing
          }
        }

        for (let loadcomb of structure.loading.combinations || []) {
          // Check for any loadcombination set to old G1 type: ng.loadcase.Type.LIMIT_STATE_STR
          if (loadcomb.limitState === ng.loadcombination.LimitState.LIMIT_STATE_STR) {
            loadcomb.limitState = ng.loadcombination.LimitState.LIMIT_STATE_VC1;
          }
        }
      }
    }
  } else if (fromGen === ng.eurocode.Generation.GENERATION_2 && toGen === ng.eurocode.Generation.GENERATION_1) {
    for (let structure of input.structures || []) {
      if (structure.loading) {
        for (let loadcase of structure.loading.loadcases || []) {
          // Check for any loadcases set to new G2 type: ng.loadcase.Type.TYPE_CONSTRUCTION_LOAD
          if (loadcase.type === ng.loadcase.Type.TYPE_CONSTRUCTION_LOAD) {
            loadcase.type = ng.loadcase.Type.TYPE_IMPOSED_LOAD; // Imposed load seems to be the closest match?
            loadcase.category = ng.loadcase.Category.CATEGORY_D; // Shopping maybe?
          }

          // Check impose loads for categories new for G2
          switch (loadcase.category) {
            case ng.loadcase.Category.CATEGORY_G2:
              loadcase.category = ng.loadcase.Category.CATEGORY_G; // Heavy traffic (general) ?
              break;
            case ng.loadcase.Category.CATEGORY_I1:
            case ng.loadcase.Category.CATEGORY_I2:
            case ng.loadcase.Category.CATEGORY_I3:
            case ng.loadcase.Category.CATEGORY_K:
              loadcase.category = ng.loadcase.Category.CATEGORY_H; // Roof (general) ?
              break;
            case ng.loadcase.Category.CATEGORY_S1:
            case ng.loadcase.Category.CATEGORY_S2:
              loadcase.category = ng.loadcase.Category.CATEGORY_C;
              break;
            case ng.loadcase.Category.CATEGORY_S3_C_G:
              loadcase.category = ng.loadcase.Category.CATEGORY_G; // Worst of C -> G ?
              break;
            case ng.loadcase.Category.CATEGORY_S3_H_K:
              loadcase.category = ng.loadcase.Category.CATEGORY_H; // Only roof (K is G2) ?
              break;
            case ng.loadcase.Category.CATEGORY_T:
              loadcase.category = ng.loadcase.Category.CATEGORY_C; // terraces and balconies -> Congregation maybe ?
              break;
            default:
              break; // do nothing
          }
        }

        for (let loadcomb of structure.loading.combinations || []) {
          // Check for any loadcombination set to new G2 type: ng.loadcase.Type.LIMIT_STATE_VC1
          if (loadcomb.limitState === ng.loadcombination.LimitState.LIMIT_STATE_VC1) {
            loadcomb.limitState = ng.loadcombination.LimitState.LIMIT_STATE_STR;
          }
        }

        // Check for user defined load combinations with new COA unique to G2 set
        for (let loadcomb of structure.loading.combinations || []) {
          switch (loadcomb.coa) {
            case ng.loadcombination.CoaType.COA_TYPE_812:
            case ng.loadcombination.CoaType.COA_TYPE_813A:
            case ng.loadcombination.CoaType.COA_TYPE_813B:
            case ng.loadcombination.CoaType.COA_TYPE_814A:
            case ng.loadcombination.CoaType.COA_TYPE_814B:
            case ng.loadcombination.CoaType.COA_TYPE_815:
            case ng.loadcombination.CoaType.COA_TYPE_816:
            case ng.loadcombination.CoaType.COA_TYPE_829:
            case ng.loadcombination.CoaType.COA_TYPE_830:
            case ng.loadcombination.CoaType.COA_TYPE_831:
            default:
              break; // do nothing
          }
        }
      }

      // Check concrete materials for C100/115
      // update to an G1 equivilent...?
    }
  }

  return input;
};

//==============================================================
